import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getOptionsArticles = async codesArticles => {
    const optionsArticles = await axios.get('/service/optionsArticles', {
        params: {
            articles: codesArticles
        }
    }).catch((e) => {
        throw new CustomException(e, 'Error fetching options articles')
    })
    return optionsArticles.data
}
